var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"admin-container"},[_c('h1',{staticClass:"col-secondary-1"},[_vm._v("Připravujeme")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }